module.exports = __webpack_public_path__ + "static/img/004.9880546.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/004.jpg
// module id = J54h
// module chunks = 1